import createRoute from '@widesk-ui/tools/createRoute';
import MenuModel   from '@models/admin/MenuModel';

export default createRoute.dashboard(
	MenuModel.pagePath('list'),
	MenuModel.serviceName,
	'MenuDashboard',
	MenuModel.localize(),
);
